export const SPANISH = Object.freeze({
    COMMON: { SAVE: "Guardar", CANCEL: "Cancelar", CLOSE: "Cerrar", BACK: "Volver" },
    TEMPLATES: { alerts: {} },
});
